'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];
    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }
  return target;
};
var _react = require('react');
var _react2 = _interopRequireDefault(_react);
var _propTypes = require('prop-types');
var _propTypes2 = _interopRequireDefault(_propTypes);
var _classnames = require('classnames');
var _classnames2 = _interopRequireDefault(_classnames);
var _Icon = require('../Icon/Icon.js');
var _Icon2 = _interopRequireDefault(_Icon);
require('./TextInput.css');
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
function _objectWithoutProperties(obj, keys) {
  var target = {};
  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }
  return target;
}
function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }
  return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }
  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

/**
 * Text input.
 */
var TextInput = function (_Component) {
  _inherits(TextInput, _Component);
  function TextInput() {
    var _ref;
    var _temp, _this, _ret;
    _classCallCheck(this, TextInput);
    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = TextInput.__proto__ || Object.getPrototypeOf(TextInput)).call.apply(_ref, [this].concat(args))), _this), _this.render = function () {
      var _this$props = _this.props,
        name = _this$props.name,
        value = _this$props.value,
        placeholder = _this$props.placeholder,
        type = _this$props.type,
        onChange = _this$props.onChange,
        onBlur = _this$props.onBlur,
        iconType = _this$props.iconType,
        size = _this$props.size,
        className = _this$props.className,
        autoComplete = _this$props.autoComplete,
        props = _objectWithoutProperties(_this$props, ['name', 'value', 'placeholder', 'type', 'onChange', 'onBlur', 'iconType', 'size', 'className', 'autoComplete']);
      var textareaClass = (0, _classnames2.default)('c-textfield', {
        'c-textfield--h-small': size === 'small'
      }, {
        'c-textfield--h-medium': size === 'medium'
      }, {
        'c-textfield--h-large': size === 'large'
      }, className);
      if (type === 'textarea') {
        return _react2.default.createElement('textarea', _extends({
          className: textareaClass,
          name: name,
          rows: '10',
          value: value,
          placeholder: placeholder,
          onChange: onChange,
          autoComplete: autoComplete || 'off'
        }, props));
      } else {
        var textfieldClass = (0, _classnames2.default)('c-textfield', className);
        var input = _react2.default.createElement('input', _extends({
          className: textfieldClass,
          type: type,
          name: name,
          value: value,
          placeholder: placeholder,
          onChange: onChange,
          onBlur: onBlur,
          autoComplete: autoComplete || 'off'
        }, props));
        if (iconType) {
          return _react2.default.createElement('div', {
            className: 'c-textfield-with-icon'
          }, input, _react2.default.createElement(_Icon2.default, {
            type: iconType
          }));
        } else {
          return input;
        }
      }
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }
  return TextInput;
}(_react.Component);
TextInput.propTypes = process.env.NODE_ENV !== "production" ? {
  /** Type of the input field*/
  type: _propTypes2.default.oneOf(['text', 'password', 'textarea', 'date']),
  /** Name for binding with fields */
  name: _propTypes2.default.string,
  /** Value of the text field */
  value: _propTypes2.default.string,
  /** Placeholder value to show when empty */
  placeholder: _propTypes2.default.string,
  /** OnChange event function */
  onChange: _propTypes2.default.func,
  /** onBlur event function */
  onBlur: _propTypes2.default.func,
  /** Additional icon to display */
  iconType: _propTypes2.default.string,
  /** Size of the textfield. (Only used for textarea fields) */
  size: _propTypes2.default.oneOf(['small', 'medium', 'large']),
  /** key for auto completion (defaults to off) */
  autoComplete: _propTypes2.default.string
} : {};
TextInput.defaultProps = {
  type: 'text'
};
exports.default = TextInput;